module.exports = __webpack_public_path__ + "img/iosStep-1.09bb14a2.webp";